/* global DocumentTouch */

(function (w, d, h, n) {
  h.className = h.className.replace(/\bno-js\b/, 'js');
  if (
    ('ontouchstart' in w || w.DocumentTouch && d instanceof DocumentTouch ||
    n.maxTouchPoints || n.msMaxTouchPoints) &&

    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
      .test(n.userAgent)
  ) {
    h.className = h.className.replace(/\bno-touch\b/, 'touch');
  }
  if (d.implementation
      .hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1')) {
    h.className = h.className.replace(/\bno-svg\b/, 'svg');
  }
}(window, document, document.documentElement, navigator));
